import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-section-icon-title',
    templateUrl: './section-icon-title.component.html',
})
export class SectionIconTitleComponent {
    @Input() title: string = '';
    @Input() icon: string = '';
    @Input() color?: string;
    @Input() defaultColor: string = 'bg-primary';
}
